<template>
  <v-btn-form :title="title" @close="cancel()">
    <v-form v-model="valid" ref="form">
      <v-card-text>
        <v-layout column>
          <v-flex v-html="text">
        </v-flex>
        <v-layout row wrap>
        <v-flex>
          <v-text-field
            label="Номер договора"
            hint=""
            :rules="[v=>!!v || 'номер должен быть указан']"
            v-model="agreementNumber"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-date-field
            label="Дата договора"
            :rules="[v=>!!v || 'дата должна быть указана']"
            hint=""
            v-model="agreementDate"
          >
          </v-date-field>  
        </v-flex>      
        </v-layout>
        <v-flex>
          <v-text-field
            prepend-icon="attach_file"
            @click:prepend="dialogOpen"
            label="Ссылка на текст претензии"
            hint=""
            v-model="item.link"
            :rules="[v=>!!v || 'cсылка должна быть указана']"
            clearable
          ></v-text-field>
        </v-flex>
        <v-flex>
          <v-date-field
            label="Предоставить ответ не позднее"
            :rules="[]"
            hint=""
            v-model="item.expiryTime"
          >
          </v-date-field>
        </v-flex>
      </v-layout>
    </v-card-text>
    </v-form>
    <template #actions>
      <v-btn :disabled="!valid" @click="add">Направить</v-btn>
      <v-spacer></v-spacer>
    </template>  
  </v-btn-form>
</template>

<script type="text/javascript">
  import formats from '../../api/formats'
  import { mapGetters } from 'vuex'
  import moment from 'moment'
  import vDateField from '../common/DateField.vue'
  import depo from '../depo'
  import vBtnForm from '../common/BtnForm'

  export default {
    name: 'post-claim-form',
    components: {vDateField, vBtnForm},
    data: () => ({
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      agreementDate: ''
    }),
    props: {
      itemId: {
        type: Number,
        default: null
      },
      fullscreen: {
        type: Boolean,
        default: false
      }
    },
    created () {
      this.item = this.getItemNew()
    },
    mounted () {
    },
    watch: {
    },
    computed: {
      ...mapGetters({
        chat: 'getChatterChat',
        profile: 'getProfile',
        getDepoUrl: 'getDepoUrl'
      }),
      partnerName () {
        return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]'
      },
      partnerInn () {
        return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]'
      },
      clientName () {
        return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]'
      },
      clientInn () {
        return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]'
      },
      expiryTime () {
        return this.item.expiryTime ? formats.formatDate(moment(this.item.expiryTime)) : ''
      },
      docLink () {
        return this.item.link ? this.item.link : ''
      },
      title () {
        return 'Направить Претензию'
      },
      text: {
        get () {
          return this.getText()
        },
        set (value) {
          this.item.text = value
        }
      }
    },
    methods: {
      add () {
        if (this.$refs.form.validate()) {
          this.item.text = this.getText()
          this.item.chatId = this.chat.id
          this.$store.dispatch('addChatterPost', this.item)
          this.edit = false
          this.cancel()
        }
      },
      cancel () {
        this.edit = false
        this.item = Object.assign({}, this.getItemNew())
        this.$emit('close')
      },
      getItemNew () {
        return {
          id: null,
          chatId: null,
          text: '',
          typeCode: 'CLAIM',
          expiryTime: moment().add(5, 'days').format(),
          link: null
        }
      },
      getText () {
        return `${this.clientName}, ИНН ${this.clientInn} направляет ${this.partnerName}, ИНН ${this.partnerInn} претензию в связи с неисполнением или ненадлежащим исполнением договора № ${this.agreementNumber} от ${formats.formatDate(this.agreementDate)} (далее – Договор) Полный текст претензии в файле по адресу: <a href="${this.docLink}">${this.docLink}</a>. Согласно условиям Договора ${this.partnerName} должен рассмотреть претензию и предоставить ответ ${this.clientName} не позднее ${this.expiryTime}.`
      },
      setDoc: function (value) {
        var docLink = this.getDepoUrl(value)
        this.item.link = docLink
      },
      dialogOpen: function () {
        depo.selectDoc(this, this.setDoc)
      }
    }
  }
</script>




// WEBPACK FOOTER //
// PostClaimForm.vue?13ec0884